export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const footerLinks = [
    { label: '焦点专题', href: '#carousel' },
    { label: '热门爆料', href: '#cards' },
    { label: '视频爆料', href: '#media' },
    { label: '爆料热度榜', href: '#ranking' },
    { label: '最新动态', href: '#updates' },
    { label: '话题标签', href: '#topics' },
    { label: '网友热评', href: '#comments' },
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问答', href: '#faq' },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                  51
                </span>
                <span className="font-heading font-bold text-lg text-background-50">
                  51吃瓜最新网址
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                51吃瓜最新网址——吃瓜爆料第一站。汇集最新51吃瓜爆料、黑料内容与热门话题，每日更新独家内幕与精彩视频合集，
                为吃瓜群众提供最快、最全、最真实的爆料资讯。
              </p>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-sm text-background-100 mb-4">快速导航</h3>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.slice(0, 5).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-sm text-background-100 mb-4">更多内容</h3>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.slice(5).map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading font-semibold text-sm text-background-100 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500 leading-relaxed">
                感谢各位合作伙伴的支持与信赖，更多合作信息敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 51吃瓜最新网址. 本站内容仅供娱乐参考。
            </p>
            <p className="text-xs text-background-600">
              吃瓜爆料第一站 · 理性吃瓜 · 快乐生活
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}